import { useTranslation } from "react-i18next";
import { Users, UserPlus } from "lucide-react";
import { Card, CardContent, Button, cn } from "@tabipla/ui";
import type { GroupMemberResponseDto } from "@tabipla/shared";

interface TripMembersSectionProps {
  members: GroupMemberResponseDto[];
  onInviteClick: () => void;
}

export function TripMembersSection({ members, onInviteClick }: TripMembersSectionProps) {
  const { t } = useTranslation();

  if (members.length === 0) {
    return null;
  }

  return (
    <Card className="overflow-hidden">
      <CardContent className="p-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
              <Users className="h-4 w-4 text-primary" />
            </div>
            <div className="flex -space-x-2">
              {members.slice(0, 5).map((member) => (
                <div
                  key={member.memberId}
                  className={cn(
                    "flex h-8 w-8 items-center justify-center rounded-full border-2 border-background text-sm font-medium",
                    member.avatarColor ? `bg-gradient-to-br ${member.avatarColor}` : "bg-muted"
                  )}
                  title={member.memberName}
                >
                  {member.avatarEmoji || member.memberName?.charAt(0).toUpperCase() || "?"}
                </div>
              ))}
              {members.length > 5 && (
                <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-background bg-muted text-xs font-medium">
                  +{members.length - 5}
                </div>
              )}
            </div>
            <span className="text-sm text-muted-foreground">
              {t("trips.membersCount", "{{count}}人", { count: members.length })}
            </span>
          </div>
          <Button variant="ghost" size="sm" onClick={onInviteClick}>
            <UserPlus className="mr-1 h-4 w-4" />
            {t("trips.addMember", "追加")}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
